import { useMemo, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FloatingTextInput } from '../reusable-elements/floating-text-input';
import { validUKPostCode, notNullOrEmpty } from "../../utils/validators";

export const AddNewPropertyModal = ({ show, handleCancel, handleSave, landlords = [] }) => {

    const [name, setName] = useState("");
    const [landlordOrOwnerId, setLandlordOrOwnerId] = useState("");
    const [doorNumberOrName, setDoorNumberOrName] = useState("");
    const [roadName, setRoadName] = useState("");
    const [town, setTown] = useState("");
    const [postCode, setPostCode] = useState("");

    const nameDescription = 'Short Name/Abbreviation for Property';
    const landlordDescription = 'Pick or Create a Landlord/Owner';
    const doorNumberOrNameDescription = 'Enter Door number or Name of property';
    const roadNameDescription = 'Enter road name of property';
    const townDescription = 'Enter name of town/city';
    const postCodeDescription = 'Enter Post Code of property';

    const landlordOptions = useMemo(() => {
        const list = Array.isArray(landlords) ? landlords : [];
        const mapped = list
            .filter(l => !!l && !!l.id)
            .map(l => ({
                id: l.id,
                label: l.displayName || l.name || l.email || l.id
            }));

        const unique = new Map();
        for (const item of mapped) unique.set(item.id, item);
        return Array.from(unique.values()).sort((a, b) => a.label.localeCompare(b.label));
    }, [landlords]);

    const handleSaveLocal = () => {
        handleSave({ name, landlordOrOwnerId, doorNumberOrName, roadName, town, postCode });
    };

    const handleCancelLocal = () => {
        setName("");
        setLandlordOrOwnerId("");
        setDoorNumberOrName("");
        setRoadName("");
        setTown("");
        setPostCode("");

        handleCancel();
    };

    const canSave = (data) => {

        return !!data.name &&
            !!data.landlordOrOwnerId &&
            !!data.doorNumberOrName &&
            !!data.roadName &&
            !!data.town &&
            !!data.postCode
    };

    return show ?
        (
            <Modal
                show={show}
                onHide={handleCancelLocal}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add New Property</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <FloatingTextInput
                        className={"mt-1 mb-15px"}
                        label={nameDescription}
                        text={name}
                        updateCallback={newValue => setName(newValue)}
                        required={true}
                        validatorFn={() => notNullOrEmpty(name)}
                    />

                    <div className="row mb-15px">
                        <label title={landlordDescription} className="form-label col-form-label col-md-4">Owner</label>
                        <div className='col-md-8'>
                            <select
                                className="form-select"
                                value={landlordOrOwnerId}
                                onChange={e => setLandlordOrOwnerId(e.target.value)}
                                title={landlordDescription}
                            >
                                <option value="">Select landlord/owner...</option>
                                {landlordOptions.map(l => (
                                    <option key={l.id} value={l.id}>{l.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <FloatingTextInput
                        className={"mt-1 mb-15px"}
                        label={doorNumberOrNameDescription}
                        text={doorNumberOrName}
                        updateCallback={newValue => setDoorNumberOrName(newValue)}
                        required={true}
                        validatorFn={() => { return notNullOrEmpty(doorNumberOrName) }}
                    />
                    
                    <FloatingTextInput
                        className={"mt-1 mb-15px"}
                        label={roadNameDescription}
                        text={roadName}
                        updateCallback={newValue => setRoadName(newValue)}
                        required={true}
                        validatorFn={() => { return notNullOrEmpty(roadName) }}
                    />

                    <FloatingTextInput
                        className={"mt-1 mb-15px"}
                        label={townDescription}
                        text={town}
                        updateCallback={newValue => setTown(newValue)}
                        required={true}
                        validatorFn={() => { return notNullOrEmpty(town) }}
                    />
                    
                    <FloatingTextInput
                        className={"mt-1 mb-15px"}
                        label={postCodeDescription}
                        text={postCode}
                        updateCallback={newValue => setPostCode(newValue)}
                        required={true}
                        validatorFn={() => { return notNullOrEmpty(postCode) && validUKPostCode(postCode) }}
                    />

                </Modal.Body>
                <Modal.Footer>
                    <div className='row w-100'>
                        <div className='col-xl-12 text-end'>
                            <Button className='me-5px' variant="secondary" onClick={handleCancelLocal}>
                                Cancel
                            </Button>
                            <Button disabled={!canSave({
                                name, landlordOrOwnerId, doorNumberOrName, roadName, town, postCode
                            })} variant="primary"
                                onClick={handleSaveLocal}>
                                <i className="fa fa-fw fa-save"></i>
                                Save
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        ) :
        (<></>);
};